define((require) => {
    "use strict";

    var _                          = require("underscore"),
        GroupNavView               = require("editor/ui/experience/editor/GroupNavView"),
        LocaleSelectorControl      = require("editor/ui/experience/editor/LocaleSelectorControl"),
        LocaleCollection           = require("shared/services/localization/LocaleCollection"),
        ActionSequence             = require("util/ActionSequence"),
        AddLocaleAction            = require("ui/actions/AddLocaleAction"),
        NavigateToExperienceAction = require("ui/actions/NavigateToExperienceAction");

    /**
     * A view that represents all variants for a specific Localization group.
     *
     * @cfg {LocalizationGroup} model
     */
    return GroupNavView.extend({

        regions: {
            localeSelectorRegion: ".add-variant-icon"
        },

        events: _.defaults({
            "click @ui.addVariantIcon": function() {
                // Overwrites parent method, do nothing.
            }
        }, GroupNavView.prototype.events),

        onRender: function() {
            this.__super();

            // Remove the plus icon and insert the new Plus icon with dropdown menu
            this.ui.addVariantIcon.empty();
            this.localeSelectorRegion.show(new LocaleSelectorControl({
                locales: LocaleCollection.remainingItems(this.model.getValues()),
                addVariant: true,
                selectHandler: this.addVariant.bind(this)
            }));
        },

        addVariant: function(localString) {
            new ActionSequence()
                .add(new AddLocaleAction(this.model, this._currentExperience, this.options.project, localString))
                .add(new NavigateToExperienceAction(this.model.get("sceneNumber")))
                .execute();
        },

        /**
         * Check which assets need to be pushed when push group button is clicked
         *
         * @returns {Object}    An object where indexes map to the actual asset
         * @private
         */
        toBePushedAssets: function() {
            return _.reduce(this.model.getUniqueEntries(), (assets, asset) => {
                if (asset[0].hasNonPushedChanges()) {
                    assets[asset[1].getCountry()] = asset[0];
                }

                return assets;
            }, {});
        },

        // Locales are always deletable
        isDeletable: function() {
            return true;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/GroupLocaleNavView.js